/** @format */
/**
 * @module
 *
 * @todo
 *
 *   - Improve popup implementation and template
 */
import {click, service} from 'nova';
import {user} from './user.js';
import {userPoolFeature} from '../userPool/config/feature.js';
import {ClickEventController} from 'nova';
import {AgeVerificationApi} from '../api/age-verification.js';
import {make} from '../core/service/env.js';
import {inject} from '../core/service/ng.js';

@service
class AgeVerification {
  #api = make(AgeVerificationApi);

  @click async popup() {
    if (user.avs?.payment) {
      inject('payment').overlay();
      return;
    }

    await this.showFskDisclaimer();
  }

  async showFskDisclaimer() {
    await userPoolFeature.popup(null, 'fsk-disclaimer', (close) => ({
      confirm: new ClickEventController(async (target) => {
        await this.confirm(target);
        close();
      }),
      cancel: new ClickEventController(async (target) => {
        await this.cancel(target);
        close();
      }),
    }));
  }

  /**
   * Performs different "confirm" actions depending on the age verification
   * options available for the user.
   *
   * - 'service': Opens the external age verification service in a new window/tab
   * - All other: Sets the user to adult (fsk 18)
   *
   * @param {Element} target
   */
  @click async confirm(target) {
    if (user.avs?.service) {
      return this.#api.start(target);
    }

    return this.#api.putAdult(target);
  }

  /**
   * Performs different "cancel" actions depending on the age verification
   * options available for the user.
   *
   * - 'service': ...
   * - All other: Sets the user to underage (fsk 12)
   *
   * @param {Element} target
   */
  @click async cancel(target) {
    if (user.avs?.service) {
      return this.#api.cancel();
    }

    return this.#api.putUnderage(target);
  }
}

export {AgeVerification};
